export default "__VITE_ASSET__wPKu7va2__"